var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashCanSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86836 5C8.31833 3.13507 9.99689 1.75 11.9999 1.75C14.0029 1.75 15.6815 3.13507 16.1314 5H20.75C21.1642 5 21.5 5.33579 21.5 5.75C21.5 6.16421 21.1642 6.5 20.75 6.5H20.0001C20 6.51741 19.9994 6.53494 19.9982 6.55256L19.1584 18.5127C19.0204 20.477 17.3868 22 15.4175 22H8.58248C6.61334 22 4.97962 20.477 4.84169 18.5127L4.00187 6.55257C4.00064 6.53494 4.00002 6.51741 4 6.5H3.25C2.83579 6.5 2.5 6.16421 2.5 5.75C2.5 5.33579 2.83579 5 3.25 5H7.86836ZM9.43717 5C9.83712 3.97583 10.8341 3.25 11.9999 3.25C13.1657 3.25 14.1627 3.97583 14.5626 5H9.43717ZM6.33801 18.4076L5.50188 6.5H18.4982L17.6621 18.4076C17.5793 19.5863 16.5991 20.5 15.4175 20.5H8.58248C7.401 20.5 6.42076 19.5862 6.33801 18.4076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanSimple);
export default __webpack_public_path__ + "static/media/trash-can-simple.dbd4a069790ec3f0438cefd934ded42d.svg";
export { ForwardRef as ReactComponent };